<div class="product-wrapper">
    <ng-template appProductsContainer></ng-template>
   
</div>